module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/november/mainvisual-present-pc_f0e261c1638fc2fe406c72691b4f6da1.webp";